import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { Button, CircularProgress } from "@mui/material";
import axios from "axios";
import { configUrl } from "config";
import ProviderSuccessModal from "learningFitbitLandingComponents/ProviderOnboardingComponents/ProviderSuccessModal";
import { useState } from "react";
function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}
const GRADIENT = "linear-gradient(135deg, rgb(255, 113, 61) 0%, rgb(245, 159, 10) 100%)";

const loadRazorpay = () =>
    new Promise((resolve) => {
        if (window.Razorpay) return resolve(true);
        const script = document.createElement("script");
        script.src = "https://checkout.razorpay.com/v1/checkout.js";
        script.onload = () => resolve(true);
        script.onerror = () => resolve(false);
        document.body.appendChild(script);
    });

const RazorpayPayment = ({ user, pricing, description, plan, onSuccess }) => {
    const [open, setOpen] = useState(false);
    const [alertMessage, setAlertMessage] = useState(null);
    const [severity, setSeverity] = useState("success");

    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [registeredProviderId, setRegisteredProviderId] = useState(null);

    const [loading, setLoading] = useState(false);
    //alerts snackbar
    const showSnackBar = (message, sev) => {
        setSeverity(sev ?? "success");
        setAlertMessage(message);
        setOpen(true);
    };
    const handleClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setAlertMessage(null);
        setOpen(false);
    };

    const createOrder = async () => {
        const res = await axios.post(
            `${configUrl.AssessmentServer}/api/Payments/createOrder/${pricing}`
        );
        return res.data.orderId;
    };

    const registerProvider = async (paymentResponse) => {
        const validFromDate = new Date();

        const validToDate = new Date(
            validFromDate.getTime() +
            plan.PackageDurationInDays * 24 * 60 * 60 * 1000
        );

        const validFrom = validFromDate.toISOString();
        const validTo = validToDate.toISOString();

        const payload = {
            providerInfo: {
                name: user.name,
                providerTypeId: 1,
                mobile: user.mobile,
                email: user.email,
                contentCuratorIds: configUrl?.contentCuratorId,
                validFrom,
                validTo
            },

            paymentverificationInfo: {
                razorpayOrderId: paymentResponse.razorpay_order_id,
                razorpayPaymentId: paymentResponse.razorpay_payment_id,
                razorpaySignature: paymentResponse.razorpay_signature,
            },

            payment: {
                paymentMethod: null,
                amount: pricing,
                couponCodeId: plan?.coupon?.id || null,
            },

            subscription: {
                resourceId: plan.id,        // package / product id
                resourceTypeId: 5,           // product
                durationInDays: plan.PackageDurationInDays,     // 2 years will change it as per course
            },
        };

        return axios.post(
            `${configUrl.AssessmentServer}/api/Payments/RegisterProvider`,
            payload
        );
    };

    const startPayment = async () => {
        try {
            setLoading(true);
            const loaded = await loadRazorpay();
            if (!loaded) {
                showSnackBar("Razorpay SDK failed", 'error');
                setLoading(false);
                return
            }

            const orderId = await createOrder();

            const options = {
                key: configUrl.REACT_APP_RAZORPAY_KEY_ID,
                amount: pricing * 100,
                currency: "INR",
                name: "Splayndid Solutions",
                description,
                order_id: orderId,

                prefill: {
                    name: user.name,
                    email: user.email,
                    contact: user.mobile,
                },

                handler: async (response) => {
                    try {
                        const registerRes = await registerProvider(response);
                        const providerId = registerRes?.data?.providerId;
                        console.log(registerRes, '-regresp')
                        if (!providerId) {
                            throw new Error("ProviderId missing");
                        }

                        // onSuccess(providerId);
                        setRegisteredProviderId(providerId);
                        setShowSuccessModal(true); //  open modal
                        // onSuccess(response); // move to next step
                    } catch (err) {
                        console.error(err);
                        showSnackBar("Provider registration failed", 'error');

                    } finally {
                        setLoading(false);
                    }
                },
            };

            new window.Razorpay(options).open();
        } catch (err) {
            console.error(err);
            showSnackBar("Payment initiation failed", 'error');
            setLoading(false);
        }
    };
    const handleContinue = () => {
        setShowSuccessModal(false);

        // move to next step
        onSuccess(registeredProviderId);
    };

    return (
        <>
            <Button
                fullWidth
                variant="contained"
                onClick={startPayment}
                disabled={loading}
                sx={{
                    mt: 2,
                    // my: 2,
                    py: 1.5,
                    fontSize: '1rem',
                    fontWeight: "600",
                    textTransform: 'none',
                    borderRadius: '0.75rem',
                    background: GRADIENT,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 1,
                    transition: "all 0.3s ease",
                    "& .arrow": {
                        transition: "transform 0.3s ease",
                    },
                    "&:hover .arrow": {
                        transform: "translateX(6px)",
                    },
                }}
            >
                {loading ? (
                    <>
                        <CircularProgress size={22} sx={{ color: "#fff" }} />
                        Processing...
                    </>
                ) : (
                    <>Proceed to Payment ₹&nbsp;{pricing}</>
                )}
            </Button>
            <ProviderSuccessModal
                open={showSuccessModal}
                onContinue={handleContinue}
            />
            <Snackbar
                open={open}
                autoHideDuration={2000}
                onClose={handleClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            >
                <Alert onClose={handleClose} severity={severity}>
                    {alertMessage}
                </Alert>
            </Snackbar>
        </>

    );
};

export default RazorpayPayment;
